import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '../button';
import { useStyleConfig, vui } from '../core';
import { cs } from '../utils';
import { useDialogContext } from './context';
/** Shows a button in the Dialog Footer, which triggers the main action of the Dialog. */
export const DialogSubmitButton = vui((props, ref) => {
    const { className, ...rest } = props;
    const styles = useStyleConfig('Dialog', useDialogContext());
    return (_jsx(Button, { className: cs('vui-dialogSubmitButton', className), ml: 2, ref: ref, text: "Submit", ...styles.submitButton, ...rest }));
});
DialogSubmitButton.displayName = 'DialogSubmitButton';
export default DialogSubmitButton;
